import { CancelError, CancellationToken } from "../Promises/CancellationTokenSource";
import { IFileStreamReader } from "./IFileStreamReader";

export class FileStreamReader implements IFileStreamReader {
    private readonly _file: File;

    /**
     * Název souboru
     */
    public get name(): string {
        return this._file.name;
    }

    /**
     * Celková velikost dat streamu
     */
    public get size(): number {
        return this._file.size;
    }

    constructor(file: File) {
        this._file = file;
    }

    /**
     * Přečte blok dat ze streamu
     * @param start Počáteční pozice čtení (od kterého bytu se má začít číst) nebo undefined pro čtení od začátku
     * @param end Koncová pozice čtení (do kterého posledního bytu se má číst - včetně) nebo undefined pro čtení do konce streamu
     * @returns Přečtená binární data
     */
    public read(start?: number, end?: number, cancellationToken: CancellationToken = CancellationToken.none): Promise<ArrayBuffer> {
        return FileStreamReader.readArrayBuffer(this._file, start, end, cancellationToken);
    }

    public getHash(/*hashType: HashType*/): Promise<string | null> {
        return Promise.resolve(null);
    }

    public static readArrayBuffer(file: File, start?: number, end?: number, cancellationToken: CancellationToken = CancellationToken.none): Promise<ArrayBuffer> {
        return new Promise((resolve, reject) => {
            cancellationToken.throwIfCancellationRequested();

            const reader = new FileReader();

            const oncancel = () => {
                reader.abort();
                reject(new CancelError(undefined, cancellationToken.id));
            };

            const reg = cancellationToken.register(oncancel);

            reader.onload = () => {
                reg.unregister();
                resolve(reader.result as ArrayBuffer);
            };

            reader.onerror = evt => {
                reg.unregister();
                reject(new Error(evt.toString()));
            };

            // end ve slice je *první byte, který se už nečte*
            const blob = file.slice(start == undefined ? 0 : start, end !== undefined ? end + 1 : file.size);
            reader.readAsArrayBuffer(blob);
        });
    }
}
